module.exports = __webpack_public_path__ + "img/w3_store_light.cfc31779.png";